<template>
  <v-dialog v-model="dialog" width="1250px" scrollable persistent>
    <template v-slot:activator="{ on }">
      <mf-button outlined color="marca-0-l10" :label="hasProduct ? 'Alterar Produto' : 'Selecionar Produto'" @click="dialog = true" />
    </template>

    <v-card>
      <v-card-text>
        <gerenciamento-produto-tabela ref="produtoTabela" v-model="selected" isSelect height="300" />
      </v-card-text>
      <v-card-actions class="px-6">
        <mf-action-buttons
          :primary-button="{
            text: 'Confirmar',
            action: confirmSelectedProduct,
            isVisible: true,
            isDisabled: Object.keys(selected).length === 0,
          }"
          :secondary-button="{
            text: 'Cancelar',
            action: closeDialog,
            isVisible: true,
          }"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import GerenciamentoProdutoTabela from '../../components/GerenciamentoProdutoTabela.vue'

export default {
  name: 'ProductStoreAddProduct',
  components: {
    GerenciamentoProdutoTabela,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    dialog: false,
    selected: {},
  }),
  computed: {
    productForms: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    hasProduct() {
      return !!this.productForms?.product?.name && !!this.productForms?.product?.name.length
    },
  },
  watch: {
    dialog(value) {
      if (value && this.$refs.produtoTabela) {
        this.$refs.produtoTabela.filterBySearch()
      }

      if (Object.keys(this.value).length > 0) {
        this.selected = this.value.product
      }
    },
  },
  mounted() {},
  methods: {
    closeDialog() {
      this.$refs.produtoTabela.clearProducts()
      // this.selected = {}
      this.dialog = false
    },
    confirmSelectedProduct() {
      this.productForms.product = this.selected
      this.closeDialog()
    },
  },
}
</script>

<style lang="scss"></style>
